import { GlobalService } from 'src/app/global.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpService } from '../../http.service';
import { WardService } from '../ward.service';

export interface PeriodicElement {
  id: number;
  name: string;
}


@Component({
  selector: 'app-ward-table',
  templateUrl: './ward-table.component.html',
  styleUrls: ['./ward-table.component.scss']
})
export class WardTableComponent implements OnInit {

  displayedColumns: string[] = ['id', 'name','ward_number', 'constituency'];
  dataSource: any;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private http: HttpService, public wardService: WardService, private global: GlobalService) {
    this.getWards();
    this.wardService.downloadWard.subscribe((is_update_ward) => {
      console.log(is_update_ward);
      if (is_update_ward) {
        this.getWards();
      }
    });
    this.global.set_master_page_title = 'Ward';
  }

  ngOnInit() {
  }

  getWards() {
    this.http.getWards().subscribe((data: PeriodicElement[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<PeriodicElement>(data);
      this.dataSource.sort = this.sort;
    });
  }

  registerWard() {
    // this.zoneService.is_display_zone_register_component = true;
    this.showWardRegister();
    console.log('register zone');
    this.wardService.wardUpdate.emit(null);
    this.wardService.set_ward_data = null;
  }


  editWard(ward) {
    this.showWardRegister();
    console.log(ward);
    this.wardService.wardUpdate.emit(ward);
    this.wardService.set_ward_data = ward;
  }


  showWardRegister() {
    this.wardService.is_display_ward_register_component = true;
  }

  hideWardRegister() {
    this.wardService.is_display_ward_register_component = false;
  }

}
